import cx from 'classnames';
import React, { useContext } from 'react';
import { useAltText, useImageUrl } from './hooks';
import styles from './VehicleImage.module.scss';
import { useIsMarketPlace, useNoVehicle } from '../TileKit/hooks';
import { TileKitContext } from '../TileKit/TileKit';

const getOptimizedUrl = (url: string, width: number) => {
  const hasQueryString = url.includes('?');

  return hasQueryString ? `${url}&width=${width}` : `${url}?width=${width}`;
};

type OwnProps = {
  trackEvent?: (
    _eventName: string,
    _customAttributes?: Record<string, unknown> | undefined
  ) => void;
};

const VehicleImage: React.FC<OwnProps> = ({ trackEvent }) => {
  const imageToUse = useImageUrl();
  const { vehicle } = useContext(TileKitContext);
  const isMarketplace = useIsMarketPlace();
  const altText = useAltText();
  const noVehicle = useNoVehicle();
  const hasBlueSteel = imageToUse === vehicle?.jellyBeanMobileUrl;

  const handleFailedLoad = (url: string) => {
    if (trackEvent == null) return;
    trackEvent('Tile Image Load Failed', {
      id: vehicle?.vehicleId,
      imageUrl: url
    });
  };

  if (noVehicle) {
    return (
      <picture
        className={cx(styles['vehicle-image'], 'skeleton')}
        data-qa="vehicle-image"
      />
    );
  }

  return (
    <picture
      className={cx(styles['vehicle-image'], { 'blue-steel': hasBlueSteel })}
      data-qa="vehicle-image"
    >
      {isMarketplace ? (
        <>
          <source media="(min-width: 0px)" srcSet={`${imageToUse}`} />
          <img
            src={imageToUse}
            alt={altText}
            loading="lazy"
            onError={() => handleFailedLoad(imageToUse)}
          />
        </>
      ) : (
        <>
          <source
            media="(min-width: 650px)"
            srcSet={getOptimizedUrl(imageToUse, 449)}
            onError={() => handleFailedLoad(getOptimizedUrl(imageToUse, 449))}
          />
          <source
            media="(min-width: 0px)"
            srcSet={getOptimizedUrl(imageToUse, 347)}
            onError={() => handleFailedLoad(getOptimizedUrl(imageToUse, 347))}
          />
          <img
            src={getOptimizedUrl(imageToUse, 347)}
            alt={altText}
            loading="lazy"
            onError={() => handleFailedLoad(getOptimizedUrl(imageToUse, 347))}
          />
        </>
      )}
    </picture>
  );
};

export default VehicleImage;
